/*
  Category grid (sections/category-grid.liquid). Below the homepage hero, the tile images wait
  until the page's high-priority image has loaded, so on phones they don't take bandwidth from
  the hero's LCP image (the first tile row starts inside the viewport, so lazy loading alone
  fetches every tile at once). The section prints the list with category-grid__list--deferred,
  which keeps the lazy images undisplayed and therefore unfetched; this script removes the class
  when the first img[fetchpriority="high"] has loaded (or failed), on the window's load event, or
  after RELEASE_AFTER_MS, whichever comes first. Without such an image it releases at once.
*/
(() => {
  const DEFERRED = 'category-grid__list--deferred';
  const RELEASE_AFTER_MS = 3000;
  let released = false;

  const release = () => {
    if (released) return;
    released = true;
    document.querySelectorAll(`.${DEFERRED}`).forEach((list) => list.classList.remove(DEFERRED));
  };

  const lcpImage = document.querySelector('img[fetchpriority="high"]');
  if (document.readyState === 'complete' || !lcpImage || lcpImage.complete) {
    release();
    return;
  }

  lcpImage.addEventListener('load', release, { once: true });
  lcpImage.addEventListener('error', release, { once: true });
  window.addEventListener('load', release, { once: true });
  setTimeout(release, RELEASE_AFTER_MS);
})();
